<template>
    <template v-if="readOnly">
        <span class=" p-col p-nogutter p-fluid p-float-label" >
            <MultiSelect class="p-col text-left" :modelValue="item.ValueList" :options="item.LabelList" optionLabel="label" optionValue="value" display="chip"
                v-bind:class="{'required_field': required == 'true', 'p-filled': item.ValueList}"
                :placeholder="$t('xtype.multiSelectField.placeHolder')"
                style="opacity: 1"
                disabled
            />
            <div v-if="item.ValueList.find(x => x == 'other')" class="p-col-12 no_padding p-grid no_margin" >
            <span class="align-item-center p-col  p-fluid p-float-label no_padding" >
            <InputText
                v-bind:class="{'fill_textfield': item.LabelList.find(x => x.value == 'other').otherValue }"
                class="p-col textfield clear_disabled" type="text" v-model="item.LabelList.find(x => x.value == 'other').otherValue"   
                disabled/>
                    <label style="">{{ item.Placeholder }}</label>
                </span>
            </div>
        </span>
    </template>
    <template v-else-if="preview">
        <MultiSelect class="p-col text-left" v-model="previewValue" :options="previewLabelList" optionLabel="label" display="chip"
            v-bind:class="{'required_field': required == 'true', 'fill_textfield': previewValue.length, 'p-filled': previewValue.length}"
            @change="changePreviewValue"
            @show="showMultiSelectOptions"
            :placeholder="$t('xtype.multiSelectField.placeHolder')"
        />
        <div v-if="previewValue.find(x => x.value=='other')" class="p-col-12 no_padding p-grid" >
            <span class="align-item-center p-col  p-fluid p-float-label no_padding" >
            <InputText
                v-bind:class="{'fill_textfield': previewOtherValue }"
                class="p-col textfield " type="text" v-model="previewOtherValue"   
                autoFocus/>
                    <label style="">{{ item.Placeholder }}</label>
                </span>
        </div>
    </template>
    <template v-else>
        <Textarea v-if="disabled" class="p-col-12 p-nogutter  textfield" v-model="selectValueArea" @input="input"  v-bind:class="{'required_field': required == 'true'}"  disabled/>
        <Textarea v-else class="p-col-12 p-nogutter textfield" v-model="selectValueArea" @input="input"  v-bind:class="{'required_field': required == 'true'}" />
        <div class=" p-mt-1 p-col-12 no_padding p-grid align-item-center ">
            <Checkbox class="no_padding p-mr-1" v-model="item.AddOtherInSelectionField" :binary="true" @change="onAddOtherInSelectionFieldChange" /> <label> {{$t('xtype.multiSelectField.otherLabel')}} </label>
            <div v-if="!item.AddOtherInSelectionField" class="p-col" />
            <InputText class="p-col p-ml-2" v-if="item.AddOtherInSelectionField" v-model="item.Placeholder" @input="input" :disabled="disabled" :placeholder="$t('xtype.multiSelectField.otherInputPlaceholder')" />
        </div>
    </template>
</template>

<script>
import Textarea from 'primevue/textarea';
import MultiSelect from 'primevue/multiselect';
import Checkbox from 'primevue/checkbox';
import InputText from 'primevue/inputtext';




export default {
    name: 'multiSelectField',
    props: ['item', 'Id', 'readOnly', 'preview', 'required', 'disabled'],
    emits: ["setDataInItem", "clearRequirePreviewField"],
    components: {
        Textarea,
        MultiSelect,
        Checkbox,
        InputText,
    },
    created() {
        if(!this.item.Placeholder) {
            this.item.Placeholder = ""
        }
    },
    data() {
        return {
            allowField: null,
            previewValue: [],
            selectValueArea: this.item.LabelList.map(x => x.label).join('\n'),
            previewOtherValue: "",
            // labelValue: null,
            // inputValue: null,
        }
    },
    computed: {
        previewLabelList: {
            get() {
                const LabelList = this.item.LabelList
                if (this.item.AddOtherInSelectionField && LabelList.findIndex(x => x.value == "other") == -1) {
                    LabelList.push({
                        label: this.$i18n.tc('xtype.multiSelectField.otherLabel'),
                        value: "other",
                        otherValue: "",
                    })
                }

                return LabelList
            }
        },
    },
    watch: {
        'item.AddOtherInSelectionField': function(AddOtherInSelectionField) {
            if (AddOtherInSelectionField) {
                if (this.item.Placeholder == "") {
                    this.item.Placeholder = this.$i18n.tc('xtype.multiSelectField.otherInputPlaceholder')
                }
            }
        }
    },
    methods: {
        input: function() {
            const LabelList = this.selectValueArea.split("\n").filter(x => x).map((x, i) => {
                return {"label": x, "value": (i+1).toString()}
            })
            const data = {
                Id: this.Id,
                Xtype: "multiSelectField",
                ItemId: this.item.ItemId,
                LabelList: LabelList,
                Placeholder: this.item.Placeholder ? this.item.Placeholder : "",
            }

            this.$emit("setDataInItem", data)
        },
        changePreviewValue: function() {
            this.$emit("clearRequirePreviewField", String(!Boolean(this.previewValue.length)))
            this.adjustMultiSelectOptionCls()
        },
        showMultiSelectOptions() {
            this.adjustMultiSelectOptionCls()
        },
        adjustMultiSelectOptionCls() {
            if(this.required == "true") {
                if(document.getElementsByClassName("p-multiselect-items p-component")[0].classList.contains("required-dropdown-options")) {
                    document.getElementsByClassName("p-multiselect-items p-component")[0].classList.remove("required-dropdown-options")
                } else {
                    if(!this.previewValue.length) {
                        document.getElementsByClassName("p-multiselect-items p-component")[0].classList.add("required-dropdown-options")
                    }
                }
            }
        },
        onAddOtherInSelectionFieldChange: function() {
            this.$store.commit('editTemplate/setEdited', true)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
